import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { CanvasContext } from './WorkflowCanvas';

const MESSAGES = {
  edit_lock: (lockedBy) => `This workflow is being edited by ${lockedBy}`,
  session_expired: () => 'Your editing session has expired. Reload to continue editing.',
};

/**
 * Compact top banner shown when the canvas is locked by another editing session.
 * Reads structured `editLockInfo` from context — no string matching.
 */
export default function EditLockBanner() {
  const { editLockInfo } = useContext(CanvasContext);

  if (!editLockInfo) return null;

  const message = MESSAGES[editLockInfo.type]?.(editLockInfo.lockedBy) || 'This workflow is locked.';

  return (
    <Box className="edit-lock-banner">
      <LockOutlinedIcon sx={{ fontSize: 14 }} />
      <Typography component="span" className="edit-lock-banner-text">
        {message}
      </Typography>
    </Box>
  );
}
